import { TooltipProvider } from "@/components/ui/tooltip";
import { TypographyLarge } from "@/components/ui/typography";

import type { QueryResponse } from "../types";

import { DataTable } from "./data-table";

type Props = {
  invoices: QueryResponse[];
  title: string;
  columnVisibility?: Record<string, boolean>;
  loading: boolean;
  width?: number;
};

export const Card = ({
  invoices,
  title,
  columnVisibility,
  loading,
  width,
}: Props) => {
  return (
    <TooltipProvider>
      <div className="space-y-2 h-full flex flex-col">
        <TypographyLarge>{title}</TypographyLarge>
        <div className="flex-1" style={{ maxWidth: width }}>
          <DataTable
            data={invoices}
            columnVisibility={columnVisibility}
            loading={loading}
          />
        </div>
      </div>
    </TooltipProvider>
  );
};
